import '/vercel/path0/dashboard_front/node_modules/@chakra-ui/storybook-addon/dist/manager.mjs';